// extracted by mini-css-extract-plugin
export default {"container":"styles_container__loh4i","title":"styles_title__xP75I","wrapper":"styles_wrapper__b7XWD","footer":"styles_footer__mQY9d"};